"use client"
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { useAuth } from "@/hooks/useAuth"
import MapLogoHorizontal from "@/assets/MAP_logo_horizontal.svg?react"

export default function LoginPage(): React.JSX.Element {
  const { isAuthenticated, isLoading, signIn } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate("/", { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate])

  if (isLoading) return <></>

  return (
    <>
      <title>Sign In - MAP Apps Platform</title>
    <div className="flex h-screen w-full overflow-hidden">
      <div className="bg-foreground hidden lg:flex lg:w-[55%] relative flex-col justify-center p-12 overflow-hidden">
        <div className="relative max-w-md ">
          <h2 className="text-background text-3xl font-bold leading-tight tracking-tight mb-4">
            ANALYTICS FOR A
            <br />
            MALARIA-FREE WORLD
          </h2>
          <p className="text-background/70 text-base leading-relaxed">
            High-resolution geospatial data and analysis to support evidence-based decisions in
            malaria control and elimination.
          </p>
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center bg-background px-8 py-12">
        <div className="w-full max-w-sm space-y-10">
          <div className="flex justify-center">
            <MapLogoHorizontal className="w-50! h-auto!" aria-label="Malaria Atlas Project" />
          </div>

          <div className="space-y-1.5">
            <p className="text-sm font-medium text-muted-foreground uppercase tracking-widest">
              Welcome to
            </p>
            <h1 className="text-3xl font-bold tracking-tight text-foreground">MAP Apps Platform</h1>

          </div>

          <div className="space-y-3">
            <Button className="w-full h-11 text-sm font-semibold" onClick={() => signIn()}>
              Sign in with The KIDS account
            </Button>
            <p className="text-center text-xs text-muted-foreground">
              Access is restricted to MAP team.
            </p>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}
